import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { AskAnalystDto } from '../dtos/analysts/askAnalyst.dto';

const askAnalystUri = 'common/v1/analysts/ask';
const userIdErrorMessage = 'Failed to get userId';

export const createAskAnAnalyst = async (askAnalystData: AskAnalystDto): Promise<AskAnalystDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error(userIdErrorMessage));
  }
  const { data } = await api.post<AskAnalystDto>(askAnalystUri, askAnalystData);
  return data;
};
